import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextIndicator: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconTextIndicator"><Path fillRule="evenodd" clipRule="evenodd" d="M16 3H21V4H19V20H21V21H16V20H18V4H16V3ZM3 5H14V6H9V19H8V6H3V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextIndicator;
